import * as Colors from '@themes/Colors'
import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  nestedScrollView: {
    flex: 1,
    paddingHorizontal: 18,
    paddingVertical: 18,
    width: '100%',
    overflowX: 'none',
    overflowY: 'visible',
    transform: [],
  },
  fullWidthScrollView: {
    flex: 1,
    width: '100%',
    overflowX: 'none',
    overflowY: 'visible',
    transform: [],
  },
  contentContainer: {
    flex: 1,
    minWidth: '100%',
    borderWidth: 1,
    borderColor: Colors.borderGray,
  },
})

export default styles
